export enum QuoteMediaAuthStatus {
  NotAuthenticated,
  Authenticating,
  Authenticated
}
